module.exports = __webpack_public_path__ + "static/8-dfdf70d0302162e4c5136dd1c3e95faa.jpg";